import { FormControlProps } from 'react-bootstrap';
import { UseFormReturn, Controller } from 'react-hook-form';
import ReactStars from 'react-stars';

/**
 * Stars Field
 *
 * Used for rating trips out of 5
 */
export default function StarsField({
  control,
  name,
  required = true,
}: StarsFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={0}
      rules={{ required }}
      render={({ field }) => (
        <div ref={field.ref} aria-labelledby={name}>
          <ReactStars
            value={field.value}
            onChange={(rating) => field.onChange(rating)}
            count={5}
            half={false}
            size={50}
            edit
            color1="#777777"
            color2="#3438d0"
            className="d-block"
          />
        </div>
      )}
    />
  );
}

export type StarsFieldProps = FormControlProps & {
  control: UseFormReturn<any>['control'];
  name: string;
  required: boolean;
};
